import { regionQueries } from './queries';
import { regionMutations } from './mutations';

export const regionService = {
  ...regionQueries,
  ...regionMutations
};
